<template>
  <wxlogin
      class="wecat-login"
      :appid="appid"
      :state="new Date().getTime().toString()"
      scope="snsapi_login"
      :redirect_uri="redirectUri"
      href="data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZxxx="
  />
</template>

<script>
import wxlogin from 'vue-wxlogin';
import { baseUrl } from '@/config/env'
// const baseUrl = "https://lab.fmaster.cn"
export default {
  components: {
    wxlogin,
  },
  props: {
    // bind、login
    type: {
      type: String,
      required: true,
    },
    redirect: {
      type: String,
      required: true,
      default: "/",
    }
  },
  data() {
    return {
      appid: "wxbcbbf0efb9759f52",
      // redirectUri: `https://lab.fmaster.cn/third-party/wecat/${this.type}?redirect=${this.redirect}`,
      redirectUri: baseUrl + this.$router.resolve({
        name: "thirdPartyWecat",
        params: {
          type: this.type
        },
        query: {
          redirect: this.redirect
        },
      }).href,
    }
  }
}
</script>

<style lang="scss">
.wecat-login {
  text-align: center;
  overflow: hidden;
}
</style>